(function() {
  function loadJQuery(callback) {
    if (window.jQuery === undefined) {
      let script = document.createElement('script');
      script.src = "https://code.jquery.com/jquery-3.6.0.min.js";
      script.onload = function() {
        jQuery.noConflict();
        callback(jQuery);
      };
      document.head.appendChild(script);
    } else {
      callback(jQuery);
    }
  }

  loadJQuery(function($) {
    
    // Initialisierung:
    $(document).ready(function(){
      $(document).on("click", "._safedelete", function(e) {
        e.preventDefault();
        e.stopPropagation();
      
        let bundleId = $(this).data("bundle-id");
        removeBundleById(bundleId);
      });
    });

    async function removeBundleById(bundleId) {
      try {
        // Schritt 1: Aktuellen Warenkorb holen
        const cart = await fetch('/cart.js').then(r => r.json());
        console.log('Aktueller Cart:', cart);
        
        // Schritt 2: Alle Items mit der Bundle-ID finden
        const bundleItems = document.querySelectorAll(`[data-bundle-id="${bundleId}"]`);
        
        if (bundleItems.length === 0) {
          console.log('Keine Items mit Bundle-ID gefunden:', bundleId);
          return;
        }
        
        // Schritt 3: Updates-Objekt vorbereiten (Menge auf 0 setzen = löschen)
        const updates = {};
        
        bundleItems.forEach(item => {
          const lineIndex = parseInt(item.dataset.index) - 1; // Array ist 0-basiert
          const lineItem = cart.items[lineIndex];
          
          if (lineItem) {
            updates[lineItem.key] = 0; // Menge 0 = löschen
          }
        });
        
        console.log('Lösche Items:', updates);
        
        // Schritt 4: Bulk-Update durchführen
        const updatedCart = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(r => r.json());
        
        console.log('✓ Bundle gelöscht:', bundleId);
        console.log('Aktualisierter Cart:', updatedCart);// Schritt 5: Seite neu laden oder UI aktualisieren
        location.reload();
        
        return updatedCart;
        
      } catch (error) {
        console.error('❌ Fehler beim Löschen:', error);
      }
    }

    document.addEventListener('change', function(e) {
      if (e.target.matches('.quantity__input') || e.target.matches('[name="updates[]"]')) {
        
        const cartItem = e.target.closest('.cart-item');
        
        if (cartItem && cartItem.dataset.bundleId) {
          const bundleId = cartItem.dataset.bundleId;
          const newQuantity = parseInt(e.target.value);
          
          const bundleItems = document.querySelectorAll(`[data-bundle-id="${bundleId}"]`);
          
          if (bundleItems.length > 1) {
            // Erst den aktuellen Warenkorb holen
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                const updates = {};
                
                bundleItems.forEach(item => {
                  const index = parseInt(item.dataset.index) - 1; // Array ist 0-basiert!
                  const lineItem = cart.items[index];
                  
                  if (lineItem) {
                    // Verwende die Line Item Key (variant_id:properties_hash)
                    updates[lineItem.key] = newQuantity;
                  }
                });
                
                console.log('Sending updates with keys:', updates);
                
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: updates })
                });
              })
              .then(response => response.json())
              .then(cart => {
                console.log('Success:', cart);
                location.reload();
              })
              .catch(error => console.error('Error:', error));
          }
        }
      }
    });
  
  });
})();



// 2in1 coupon kampagne

function countDataValues(className, dataKey) {
    const elements = document.querySelectorAll(`.${className}`);
    const counts = {};

    elements.forEach(el => {
        const value = el.dataset[dataKey];
        if (!value) return;

        counts[value] = (counts[value] || 0) + 1 * el.dataset["quantity"];
    });

    return counts;
}

async function clearDiscount(){
  try {

    const response = await fetch( '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });
    const data = await response.json();
   // console.log("note deleted");
   // console.log(data);

  } catch (error) {
    console.error('❌ Fehler:', error);
  }
}

async function switchDiscount(newCode) {
  try {
    // Schritt 1: Rabatt entfernen
    //await fetch('/discount/CLEAR');
    //console.log('✓ Rabatte entfernt');

    if(newCode != false){
  // Schritt 2: Neuen Rabatt anwenden
     /* const response = await fetch(`/discount/${newCode}`);
      const data = await response.json();
      console.log("note added");
      console.log(data);*/

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: newCode })
      });

      const data = await response.json();
      console.log("note added");
      console.log(data);
    }    

    
    // Schritt 3: Aktualisierten Warenkorb holen
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('✓ Warenkorb aktualisiert:', cart);
    
    // Schritt 4: NUR Rabattanzeige aktualisieren
    updateDiscountDisplay(cart);
    
    return cart;
    
    
  } catch (error) {
    console.error('❌ Fehler:', error);
  }
}

function checkDiscounts(){
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Array mit allen angewendeten Rabatten auf Warenkorb-Ebene
      console.log("Angewendete Rabatte:", cart.cart_level_discount_applications);
      
      // Einzelne Artikel auf Rabatte prüfen
      cart.items.forEach(item => {
        console.log(`Rabatte für ${item.title}:`, item.line_level_discount_allocations);
      });
    });
}

// Nur Rabattanzeige aktualisieren - angepasst für deine Struktur
function updateDiscountDisplay(cart) {
  const discountList = document.querySelector('.footer-discounts');
  
  if (!discountList) return;
  
  // Liste leeren
  discountList.innerHTML = '';
  
  if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
    cart.cart_level_discount_applications.forEach(discount => {
      const discountAmount = (discount.total_allocated_amount / 100).toFixed(2).replace('.', ',');
      
      const li = document.createElement('li');
      li.className = 'discount text-sm flex items-center';
      li.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-discount icon--extra-small" viewBox="0 0 14 15" fill="none">
          <path d="M2.31547 8.06547C2.23358 7.98349 2.18755 7.87236 2.1875 7.75648V2.6875H7.25648C7.37236 2.68755 7.48349 2.73358 7.56547 2.81547L12.997 8.24703C13.079 8.32907 13.1251 8.44031 13.1251 8.55629C13.1251 8.67227 13.079 8.78351 12.997 8.86555L8.36719 13.497C8.28515 13.579 8.17391 13.6251 8.05793 13.6251C7.94195 13.6251 7.83071 13.579 7.74867 13.497L2.31547 8.06547Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M4.59375 5.75C4.95619 5.75 5.25 5.45619 5.25 5.09375C5.25 4.73131 4.95619 4.4375 4.59375 4.4375C4.23131 4.4375 3.9375 4.73131 3.9375 5.09375C3.9375 5.45619 4.23131 5.75 4.59375 5.75Z" fill="currentColor"></path>
        </svg>
        <span>${discount.title}</span>
        <span class="font-body-bold">(-${discountAmount})</span>
      `;
      
      discountList.appendChild(li);
    });
    
    discountList.style.display = 'flex';
    //console.log('✓ Rabatt angezeigt');
  } else {
    discountList.style.display = 'none';
    //console.log('✓ Keine Rabatte aktiv');
  }
  
  // Optional: Gesamtwert aktualisieren
  const subtotalValue = document.querySelector('.totals__subtotal-value');
  if (subtotalValue && cart.total_price) {
    subtotalValue.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' Euro';
  }
}


// Hilfsfunktion
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

document.addEventListener('DOMContentLoaded', async function () {

    //hinweis buttonactivator
    const form = document.getElementById('cart');
    const checkbox = document.getElementById('health-accepted');
    const submitButtons = document.getElementById('cart-buttons');

    function toggleSubmitButtons() {
        submitButtons.classList.toggle('is--active');
    }

    // Listener
    checkbox.addEventListener('change', toggleSubmitButtons);
    // Einmal zahlen, zweimal freuen - Einstärkenbrille 1,67 | 54211891069273
    

    return;

    // 2 in 1 Kampagne

    const activeproducts = countDataValues("cart-item-addon", "articleId");
    await clearDiscount();
    setCartNotice(false);

    //checkDiscounts();
    
    if(activeproducts['54211891036505'] >= 2){
       switchDiscount('Einmal zahlen - zweimal freuen - Einstärkenbrille 1.6');
    }else if(activeproducts['54211891036505'] == 1){
      setCartNotice(70);
    }

    if(activeproducts['54211891069273'] >= 2){
       switchDiscount('Einmal zahlen - zweimal freuen - Einstärkenbrille 1.67');
    }else if(activeproducts['54211891069273'] == 1){
      setCartNotice(70);
    }

    /*if(activeproducts['54756385522009'] >= 2){
      switchDiscount('2in1 - Gleitsicht vergrössert 1.5');
    }else if(activeproducts['54756385522009'] == 1){
      setCartNotice(70);
    }*/
    
    if(activeproducts['54756402430297'] >= 2){
       switchDiscount('2in1 - Gleitsicht vergrössert 1.6');
    }else if(activeproducts['54756402430297'] == 1){
      setCartNotice(80);
    }

    if(activeproducts['54756403872089'] >= 2){
       switchDiscount('2in1 - Gleitsicht grösstmöglich 1.6');
    }else if(activeproducts['54756403872089'] == 1){
      setCartNotice(100);
    }

    if(activeproducts['54756403904857'] >= 2){
       switchDiscount('2in1 - Gleitsicht grösstmöglich 1.67');
    }else if(activeproducts['54756403904857'] == 1){
      setCartNotice(120);
    }    
});

function setCartNotice(discount) {
    afterClass = "cart__header";
    blockId = "campaignMessage";
    htmlContent = "<div class='campaign-message'><h1>Jetzt doppelt freuen!</h1><p>Lege einfach eine zweite Brille in den Warenkorb und sichere dir "+discount+"€ bei der ‚Einmal zahlen, zweimal freuen‘-Aktion. </p></div>";
  
    const anchor = document.querySelector(`.${afterClass}`);
    if (!anchor) return;

    // remove existing block if present
    const existing = document.getElementById(blockId);
    if (existing) existing.remove();

    if(discount == false){
      return;
    }

    // create new block
    const block = document.createElement("div");
    block.id = blockId;
    block.innerHTML = htmlContent;

    // insert after the anchor element
    anchor.insertAdjacentElement("afterend", block);
}